import { useEffect, useState } from "react";

import API from "utils/api";
import { useRating, useUser } from "utils/hooks";
import { anyToHash, filtersToQueryParams } from "utils/misc";

export default function useTrending(type, filters = {}, options = { enabled: true }) {
  const { rating } = useRating();
  const { token } = useUser();

  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchTrending() {
      setLoading(true);

      const { response, data } = await API.fetchTrending(token, type, filtersToQueryParams({ rating, ...filters }));

      if (response.ok) {
        setResult(data);
        setLoading(false);
      }
    }

    if (options.enabled === true) {
      fetchTrending();
    }
  }, [options?.enabled, type, anyToHash({ ...filters, rating })]);

  return {
    loading,
    results: result?.results ?? [],
  };
}
